import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import { Field } from 'redux-form';
import QuestionnaireItem from '../QuestionnaireItem';
import ValidationError from '../ValidationError';

import './styles.module.css';

/**
 * Renders a set of questionnaire radio buttons
 * 
 * There is a problem with customised radio buttons in redux-form
 * The method used here is to work around it by using a regular field
 * Real radio buttons are still written to the DOM for accessibility reasons
 * Then these are hidden and the custom implementation performed via CSS
 */
export class QuestionnaireFieldRadio extends Component {
  constructor(props) {
    super(props);
    this.renderInputs = this.renderInputs.bind(this);
    this.renderInput  = this.renderInput.bind(this);
  }

  /* Iterate all options and create a radio for each */
  renderInputs(props) {
    return (
      <Fragment>
        {props.meta.error && <ValidationError key="error" error={props.meta.error} />}
        {props.options.map(this.renderInput.bind(null, props))}
      </Fragment>
    );
  }

  /* Creates a customised radio button */
  renderInput(props, option) {
    const checked = props.input.value === option;
    const style   = checked ? 'label checked' : 'label unchecked';

    return (
      <label key={option} styleName={style}>
        <input {...props.input} styleName="input" type="radio" value={option} checked={checked} />
        {option}
      </label>
    );
  }

  render() {
    const { name, options, validate, children } = this.props;
    return (
      <QuestionnaireItem {...this.props}>
        {children}
        <Field component={this.renderInputs} name={name} options={options} />
      </QuestionnaireItem>
    );
  }
}

QuestionnaireFieldRadio.propTypes = {
  name: PropTypes.string.isRequired,
  prompt: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object
  ]),
  help: PropTypes.string,
  comments: PropTypes.bool,
  validate: PropTypes.func,
  links: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
  }))
};

export default QuestionnaireFieldRadio;